import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { Typography } from '@material-ui/core'
import QuestionDifficulty from '../Content/QuestionDifficulty'

const QuestionHeader = styled.div`
  display:flex;
  flex-wrap: wrap;
  &.question {
    justify-content: space-between;
  }
`

const ExamQuestionHeader = ({ questionNumber, currentQuestion, testInfo, content, type }) => {
  const [description, setDescription] = useState((testInfo || {}).descricao)
  const [name, setName] = useState()

  const getNameAndYear = (name, year) => {
    if (!!name && !!year) {
      return (description !== (null || undefined) ? name + ' - ' + description + ' - ' + year : name + ' - ' + year)
    } else if (!!name) {
      return (description !== (null || undefined) ? name + ' - ' + description : name)
    }
  }

  // eslint-disable-next-line
  const handleInstitutions = () => {
    if (type === 'Prova') return (
      setDescription((testInfo || {}).descricao),
      getNameAndYear(((content || {}).instituicao || {}).nome, (content || {}).ano)
    )
    if (type === 'Prova Personalizada') return (
      setDescription(((currentQuestion || {}).prova || {}).descricao),
      getNameAndYear((((currentQuestion || {}).prova || {}).instituicao || {}).nome, ((currentQuestion || {}).prova || {}).ano)
    )
    if (type === 'quiz') return getNameAndYear(((testInfo || {}).instituicao || {}).nome, (testInfo || {}).ano)
  }  

  useEffect(() => {
    setDescription((testInfo || {}).descricao)
    setName(handleInstitutions())
  }, [testInfo, handleInstitutions])

  return (
    <>
      <QuestionHeader className={questionNumber > -1 ? 'question' : ''}>
        {questionNumber > -1 && <>
          {type !== 'Simulado' ? <Typography gutterBottom variant="body2" component="p">
            {name}
          </Typography>
            :
            <Typography gutterBottom variant="body1" component="p">
              {`${(testInfo || {}).descricao ? (testInfo || {}).descricao : ''}`}
            </Typography>}
          <QuestionDifficulty questionContent={(currentQuestion || {}).dificuldade !== null ? (currentQuestion || {}).dificuldade : null} />
        </>}
      </QuestionHeader>
    </>
  )
}

export default ExamQuestionHeader